import {setPx, validatenull, addParam, loadFont, flattenTree} from './util';
import {markRaw, nextTick, unref, watch, watchEffect} from 'vue'
import config from './config';
// import * as mqtt from 'mqtt'
import commonOption from './option'
import crypto from '@/utils/crypto'
import {getFunction, funEval, uuid} from '@/utils/utils';
import COMMON, {website} from '@/config'
import {
  BIG_JUMP_TYPE,
  DATA_SOURCE_TYPE,
  DRILL_TYPE, EVENT_LIST, EVENT_TYPE, LINK_TYPE,
  METRIC_TYPE, OPEN_PAGE_TYPE,
  PARAM_TYPE,
  SPREAD_SHEET_TYPE,
  ABS_SYMBOL, ServiceTypeList, DEFAULT_VALUE_TYPR,
} from "@/option/common/dict";
import {cloneDeep, groupBy, uniq} from "lodash-es";
import util from "@/option/common/util";
import qs from 'qs'
import ChartNav from '@/components/drillNav.vue'
import {useEventBus, useEventListener} from "@vueuse/core";
import {INDEX_TYPE} from "../option/common/dict";
import {zkFun} from '@/utils/formulaFunc'
import {dataCenterDao} from "@/option/common/dao";
import Pagenation from '@/components/HorizontalBar/pagenation.vue'
import { ElMessage } from "element-plus";

window.zkFun = zkFun
export default (() => {
  return {
    components: {ChartNav, Pagenation},
    props: {
      stylesFormatter: Function,
      dataFormatter: Function,
      titleFormatter: Function,
      labelFormatter: Function,
      clickFormatter: Function,
      dblClickFormatter: Function,
      mouseEnterFormatter: Function,
      mouseLeaveFormatter: Function,
      sqlFormatter: Function,
      recordFormatter: Function,
      formatter: Function,
      echartFormatter: Function,
      dataQueryType: String,
      dataQuery: String,
      dataHeader: String,
      fontFamily: String,
      width: {
        type: [Number, String],
        default: 600
      },
      height: {
        type: [Number, String],
        default: 600
      },
      theme: {
        type: String
      },
      child: {
        type: Object,
        default: () => {
          return {};
        }
      },
      record: {
        type: String
      },
      public: {
        type: String
      },
      sql: {
        type: String
      },
      time: {
        type: Number,
        default: 0
      },
      proxy: {
        type: Boolean
      },
      url: {
        type: String
      },
      wsUrl: {
        type: String
      },
      mqttUrl: {
        type: String
      },
      mqttConfig: {
        type: Object,
        default: () => {
          return {};
        }
      },
      disabled: {
        type: Boolean,
        default: true
      },
      dataType: {
        type: Number,
        default: 0
      },
      dataMethod: {
        type: String,
        default: 'get'
      },
      id: {
        type: String,
        default: 'main_' + uuid()
      },
      data: {
        type: [Object, String, Array]
      },
      component: {
        type: Object,
        default: () => {
          return {};
        }
      },
      option: {
        type: Object,
        default: () => {
          return {};
        }
      },
      //  此处保存的是兼容大屏和爱搭的配置 所以不放option里面 不然爱搭改动较大
      prop: {
        type: Object,
        default: () => {
          return {};
        }
      },
      // 这个是爱搭的页面变量
      datas: {},
      // 关联数据
      linkData: {
        default: () => {
          return {};
        }
      },
      themeCfg: {
        default: () => {
          return {
            gapSet: {
              rowGap: '',
              columnGap: '',
              paddingTop: '',
              paddingRight: '',
              paddingBottom: '',
              paddingLeft: '',
            },
            titleSet: {},
            chartSet: {},
            sheetSet: {},
            searchSet: {},
          };
        }
      },
      isTrendChart: {
        type: Boolean,
        default: false
      },
      isRankChart: {
        type: Boolean,
        default: false
      }
    },
    inject: {
      editorType: {},
      // 页面参数
      pageArgs: {
        default() {
          return {}
        }
      },
      rootPageArgs: {
        default() {
          return {}
        }
      },
      pageConfig: {
        default() {
          return {}
        }
      },
      container: {
        default() {
          return {}
        }
      }
    },
    mixins: [commonOption],
    data() {
      return {
        isHovering: false,
        pageCount: 0,
        pageIndex: 1,
        thisArg: this,
        multiActionsParam: {
          thisArg: this,
          clickParams: {},
          // 显示多路径下钻等浮层
          showMultiAction: false,
          component: this.component,
          themeCfg: this.themeCfg,
          isDark: this.themeCfg?.colorType === 'deep_color'
        },
        currentDrillRouteIndex: -1,
        // 保存从后台获取的原始数据
        originDataChart: {},
        currentClickItem: {},
        fetchParam: {},
        originDim: {},
        drillIndex: -1,
        drillDataList: [],
        headerHeight: '',
        checkChart: '',
        myChart: '',
        dataOldChart: [],
        dataChart: [],
        dataAxios: {},
        dataParams: {},
        refList: [],
        wsClient: {},
        mqClient: {},
        styles: {},
        appendCheck: {},
        appendObj: {},
        appendList: [],
        className: '',
        // 下钻维度list
        drillDimList: [],
        // 下钻点击的e list
        drillClickList: [],
      };
    },
    watch: {
      'option.showPage': {
        handler() {
          if (this.option.showPage) {
            this.setPageData()
            this.startPageInterval()
          } else {
            this.clearPageInterval()
            this.fetchDimentionData().then((data) => {
              this.updateChart()
            })
          }
        }
      },
      'option.pageSize': {
        handler() {
          this.initPageInfo()
        }
      },
      'option.autoPage': {
        handler() {
          if (this.option.autoPage) {
            this.startPageInterval()
          } else {
            this.clearPageInterval()
          }
        }
      },
      'option.pageInterval': {
        handler() {
          if (this.option.autoPage) {
            this.startPageInterval()
          }
        }
      },
      drillIndex(nv, ov) {
        let drillItem = this.originDim
        if (this.drillIndex > -1) {
          drillItem = this.getDrillITem(this.drillIndex);
          if (!this.dynamicDrill) {
            this.prop.dimensions[0].code = drillItem.code;
            this.prop.dimensions[0].name = drillItem.name;
          }
        } else {
          this.currentDrillRouteIndex = -1
          this.prop.dimensions[0].code = this.originDim.code;
          this.prop.dimensions[0].name = this.originDim.name;
        }
        // 处理下钻list
        if (nv > ov) {
          this.drillDimList.push(drillItem)
          this.drillClickList.push(this.currentClickItem)
          let dataItem = this.dataChart?.find(el => el[this.dcode] == this.currentClickItem.name || el[this.dcode]?.value === this.currentClickItem.name)
          this.drillDataList.push(dataItem)
        } else {
          if (nv < 0) {
            this.setLinkData(this.dcode, '', {})
            this.drillDimList = []
            this.drillClickList = []
            this.drillDataList = []
          } else {
            this.setLinkData(this.dcode, '', this.drillDataList[nv])
            this.drillDimList.splice(nv + 1)
            this.drillClickList.splice(nv + 1)
            this.drillDataList.splice(nv + 1)
          }
        }
        this.$emit('drillIndex', {bsItem: this, drillItem, nv, ov, drillIndex: this.drillIndex})
        // 这里暂时去掉 上面修改了dimensions 会自动触发updateData
        setTimeout(() => {
          this.updateData()
        }, 200)
      },
      data() {
        this.updateData()
      },
      dataAppend(val) {
        this.appendObj = {};
        this.appendList = []
        if (!val) {
          this.appendCheck = clearInterval(this.appendCheck)
        } else {
          this.dataChart = []
        }
        this.updateData()
      },
      echartFormatter() {
        this.updateChart();
      },
      width() {
        this.$nextTick(() => {
          this.updateChart();
        })
      },
      height() {
        this.$nextTick(() => {
          this.updateChart();
        })
        this.updateChart();
      },
      theme() {
        this.myChart.dispose();
        this.init();
      },
      themeCfg: {
        deep: true,
        handler() {
          this.updateChart();
        }
      },
      option: {
        handler() {
          this.updateChart();
          if (this.option?.referenceCustomSet?.length || this.option?.rightReferenceCustomSet?.length) {
            this.updateData()
          }
          if (this.option.dataRefreshInterval) {
            this.updateData()
          }
        },
        deep: true
      },
      prop: {
        handler(nv, ov) {
          this.updateData()
        },
        deep: true,
        // onTrigger(e) {
        //   // 当 count.value 被更改时触发
        // }
      },
      isDataCenter(nv) {
        if (this?.container?.deleteProp) {
          if (nv) {
            this.container.deleteProp(undefined, this.$attrs.index || this.id)
          }
        }
      }
    },
    computed: {
      dynamicDrill() {
        if (!this.isDrill) return false;
        let set = this.prop.dimensions?.[0]?.set;
        if (set?.drillActions?.length) {
          return set?.drillActions[0].drillType === DRILL_TYPE.DYNAMIC
        } else {
          return false;
        }
      },
      isDark() {
        return this.themeCfg?.colorType === 'deep_color'
      },
      triggerRef() {
        return this.option?.ref
      },
      // 是否配置了下钻 下钻需要额外获取模型配置
      isDrill() {
        let set = this.prop.dimensions?.[0]?.set;
        return (set?.drillType && set?.drillList?.length) || set?.drillActions?.length
      },
      currentDrillSet() {
        let set = this.prop.dimensions?.[0]?.set;
        if (set?.drillActions?.length && this.currentDrillRouteIndex > -1) {
          return this.dynamicDrill ? set?.drillActions[0] : set?.drillActions[this.currentDrillRouteIndex]
        }
        return {}
      },
      MinusDrillHeightStyle() {
        return {
          ...this.styleChartName,
          height: this.drillIndex > -1 ? setPx(this.height - 20) : setPx(this.height)
        }

      },
      // 是否开启自动跳转
      isAutoJump() {
        return this.prop?.bigJump
      },
      // 是否是爱搭的服务
      isDataCenter() {
        if (!this.prop.dataSourceType) return false;
        // 图片不走这里
        if (this.component.prop == 'sheet') {
          // 明细表配列
          if (this.option.spreadSheetType === SPREAD_SHEET_TYPE.DETAIL) {
            return this.prop?.columns?.length
          } else {
            // 透视表配行列指标
            return this.prop?.rows?.length && this.prop?.columns?.length && this.prop?.metrics?.length
          }
        }
        if (this.component.prop == 'sheet') {
          if (this.prop?.metrics?.length) {
            if (this.prop.dataSourceType === DATA_SOURCE_TYPE.DATA_CENTER) {
              // 配置了模型才请求接口
              if (this.prop?.dataCenter?.modelId) {
                return true
              }
            } else if (this.prop.queryAction?.actionId) {
              return true
            }
          }
        }
        if (this.component.prop == 'indexCard' || this.component.prop == 'text' || this.component.prop == 'valueText') {
          return this.prop?.metrics?.length
        }
        // 小下拉选择器，只有维度也要可以请求数据
        if (this.component.prop == 'basicSelect') {
          return this.prop?.dimensions?.length
        }

        if (this.component.prop == 'textAreaModel') {
          return this.prop?.dimensions?.length || this.prop?.metrics?.length
        }
        // 至少需要配置指标 才请求数据 之前需要维度和指标都配置
        // 新增无指标，有维度、经纬度，也请求数据
        const mapQueryCondition = this.prop?.longitude?.length && this.prop?.latitude?.length && this.prop?.dimensions?.length
        if (this.prop?.metrics?.length || mapQueryCondition) {
          if (this.prop.dataSourceType === DATA_SOURCE_TYPE.DATA_CENTER) {
            // 配置了模型才请求接口
            if (this.prop?.dataCenter?.modelId) {
              return true
            }
          } else if (this.prop.queryAction?.actionId) {
            return true
          }
        }
        // 表格只配置列就可以了
        if (this.prop?.columns?.length || this.prop?.metricsR?.length || this.prop?.metricsL?.length) {
          return true
        }
        return false;
      },
      count() {
        return this.option.count;
      },
      dataAppend() {
        return this.option.dataAppend;
      },
      dataChartLen() {
        return (this.dataChart || []).length;
      },
      switchTheme() {
        return this.validData(this.option.switchTheme, false);
      },
      name() {
        // 处理控制台报错临时添加
        let className = typeof this.$el.className === 'string' ? this.$el.className.split(' ')[0] : `${new Date().getTime()}`
        const result = className.replace(config.name, '');
        return result;
      },
      minWidth() {
        const val = this.option.minWidth;
        if (val > this.width) return val;

      },
      styleChartName() {
        const obj = {
          fontFamily: loadFont(this.component.fontFamily),
          width: setPx(this.minWidth || this.width),
          height: setPx(this.height),
          opacity: this.component.opacity || 1,
          transform: `scale(${this.component.scale || 1}) perspective(${this.component.perspective || 500}px) rotateX(${this.component.rotateX || 0}deg) rotateY(${this.component.rotateY || 0}deg) rotateZ(${this.component.rotateZ || 0}deg)`
        };
        if (this.option.scrollXFlag && this.option.xAxisWidth) {
          obj.width = setPx(this.option.xAxisWidth);
          obj.height = '100%';
          this.$nextTick(() => {
            this.updateChart()
          })
        } else {
          obj.width = setPx(this.minWidth || this.width)
          obj.height = setPx(this.height)
          this.$nextTick(() => {
            this.updateChart()
          })
        }
        return obj;
      },
      styleSizeName() {
        return Object.assign({
          width: setPx(this.width),
          height: setPx(this.height),
        }, (() => {
          let obj = {};
          if (this.minWidth) {
            obj = {
              ...obj,
              overflowX: 'auto',
              overflowY: 'hidden'
            };
          }
          if (this.option.scrollXFlag && this.option.xAxisWidth) {
            obj.overflowX = 'auto';
            obj.overflowY = 'hidden';
          }
          return obj;
        })(), this.styles);
      },
      dcode() {
        return this.prop?.dimensions?.[0]?.code;
      },
      gcode() {
        return this.prop?.groups?.[0]?.code;
      },
      mcode() {
        return this.prop?.metrics?.[0]?.code;
      },
      currentLinkData() {
        // 联动数据变化 更新数据
        // 注释，todo，待验证
        // this.updateData()
        // 兼容爱搭和大屏
        return this.linkData[this.$attrs.index || this.id]
      },
      // 当前组件的联动维度
      currentLinkDim() {
        let res = []
        let all = this.currentLinkData
        for (const allKey in all) {
          let el = all[allKey]
          if (allKey !== 'name' && el.type === INDEX_TYPE.DIMENSION) {
            res.push(el)
          }
        }
        return res
      },
      // 当前组件的联动指标
      currentLinkMetrics() {
        let res = []
        let all = this.currentLinkData
        for (const allKey in all) {
          let el = all[allKey]
          if (allKey !== 'name' && el.type === INDEX_TYPE.METRIC) {
            res.push(el)
          }
        }
        return res
      },
      drillColor() {
        if (this.prop?.dimensions?.length) {
          return this.prop.dimensions?.[0]?.set?.drillLabelColor || "#171a1d";
        }
        return "#171a1d";
      },
      pageParams() {
        if (this.pageArgs) {
          // 跳转当前页面仅更新参数时，pageArgs不能更新，因此加一层逻辑
          const injectArgsStr = JSON.stringify(this.pageArgs)
          const curRouterArgs = JSON.stringify(this.$route.query)
          if (injectArgsStr !== curRouterArgs && this.editorType === 1) {
            location.reload();
          }
        }
        return this.pageArgs || this.rootPageArgs
      }
    },
    mounted() {
      this._initUnloadData = !!this.prop.initUnloadData
      this.init();
      this.originDim = cloneDeep(this.prop?.dimensions?.[0])
      this.watchLinkData()
      if (this.isDrill) this.getModelInfo()
      this.setEvent()
    },
    methods: {
      getOriginData(dimensions, index) {
        return dimensions[index]
      },
      getTrendData() {
        let dim = this.prop?.trendDim?.map(el => el.code)
        let metrics = this.prop.metrics
        const groupByDim = groupBy(this.dataChart, (item) => {
          let key = dim?.map(el => {
            let _el = item[`${el}`]
            if (_el?.hasOwnProperty('value')) {
              return _el?.value || ''
            } else {
              return _el || ''
            }
          })?.join('-')
          return key
        });
        let groups = Object.keys(groupByDim)
        let CartesianList = []
        let _op = this.getDimentionOption()
        metrics.forEach((el) => {
          groups.forEach((_el) => {
            CartesianList.push({
              name: `${_el}-${el.name}`,
              code: el.code,
              data: _op?.categories?.map((___el) => {
                let res = groupByDim[_el].find(__el => {
                  let v
                  if (__el[this.dcode]?.hasOwnProperty('value')) {
                    v = __el[this.dcode]?.value
                  } else {
                    v = __el[this.dcode]
                  }
                  return v === ___el
                })
                return res?.[el.code]?.hasOwnProperty('value') ? res?.[el.code]?.value : res?.[el.code]
              })
            })
          })
        })
        return CartesianList
      },
      watchConditionRec(list) {
        list.forEach((el) => {
          if (el?.conditions?.length) {
            let cache = cloneDeep(el?.conditions?.filter((_el) => _el.code))
            cache.forEach((_el) => {
              if (_el.valueType === "pageEntry") {
                if (_el.bindParam) {
                  if (_el.bindParam.type === PARAM_TYPE.VARIABLE || _el.bindParam.type === PARAM_TYPE.LINK) {
                    watch(() => util.deepGet(this.datas, _el.bindParam, '', this.$attrs, this.pageParams, this.linkData), (val, odlVal) => {
                      if (String(val) !== String(odlVal)) {
                        this.updateData({})
                      }
                    }, {immediate: true})
                  }
                }
              }
            });
          }
          if (el?.children?.length) {
            this.watchConditionRec(el.children);
          }
        });
      },
      watchLinkData() {
        let prop = this.prop
        // 过滤初次有联动的请求 一个是业务 一个是数据中台，数据中台那块有递归所以用了全局变量 这里就用普通变量就ok了
        if (prop.dataSourceType === DATA_SOURCE_TYPE.DATA_CENTER) {
          if (prop.filterDatas) {
            this.watchConditionRec([prop.filterDatas])
          }
        } else if (prop.dataSourceType === DATA_SOURCE_TYPE.BIZ) {
          if (prop?.conditions?.length) {
            prop.conditions.forEach((el) => {
              if (el.bindParam) {
                if (el.bindParam.type === PARAM_TYPE.VARIABLE || el.bindParam.type === PARAM_TYPE.LINK) {
                  watch(() => util.deepGet(this.datas, el.bindParam, '', this.$attrs, this.pageParams, this.linkData), (val, odlVal) => {
                    this.updateData({})
                  }, {immediate: true})
                }
              }
            });
          }
        }
      },
      init() {
        this.refList = this.getItemRefs()
        this.className = `animated ${this.component.animated || ''}`
        const main = this.$refs[this.id];
        if (main) {
          // 判断是否图表去初始化
          const isChart = config.echart.includes(this.name);
          if (isChart) this.myChart = markRaw(window.echarts.init(main, this.theme, {devicePixelRatio: 2}));
        }
        if (this.id.indexOf('copy') >= 0) {
          // 针对放大功能，视图没渲染完直接更新，会出现数据未加载成功的异步BUG，临时方案, 延迟更新数据
          setTimeout(() => {
            this.updateChart();
            this.updateData()
          }, 300)
        } else {
          this.updateChart();
          this.updateData()
        }
      },
      getItemRefs() {
        let refList = this.$parent.$parent.$refs;
        let result = {}
        Object.keys(refList).forEach(ele => {
          if (ele.indexOf(COMMON.NAME) !== -1) {
            result[ele.replace(COMMON.NAME, '')] = refList[ele][0]
          }
        })
        return result;
      },
      updateChart() {

      },
      updateClick(params) {
        let refList = this.getItemRefs();
        let indexList = this.child.index;
        let paramName = this.child.paramName;
        let paramValue = this.child.paramValue || 'value';
        let paramList = this.child.paramList || []
        let p = {};
        if (!validatenull(paramName) && !validatenull(paramValue)) {
          p[paramName] = params[paramValue]
        }
        if (!validatenull(paramList)) {
          paramList.forEach(ele => {
            p[ele.name] = params[ele.value]
          })
        }
        if (!validatenull(p)) {
          Object.keys(refList).forEach(ele => {
            if (indexList.includes(ele)) refList[ele].updateData(p);
          })
        }
      },
      updateAppend(result) {
        if (this.validatenull(this.appendObj)) {
          this.appendList = result
          this.appendObj = result[0]
        } else {
          let appendList = [];
          for (let i = 0; i < result.length; i++) {
            const ele = result[i]
            if (ele.id === this.appendObj.id) break
            else appendList.push(ele)
          }
          this.appendObj = result[0]
          appendList.reverse().forEach(ele => {
            this.appendList.unshift(ele);
          })
        }
        if (this.validatenull(this.appendCheck)) {
          this.appendCheck = setInterval(() => {
            let length = this.appendList.length - 1;
            if (length >= 0) {
              let obj = this.appendList.splice(length, 1)[0]
              this.dataChart.unshift(obj);
              let len = this.dataChart.length;
              if (len > this.count) {
                this.appendList.splice(len - 1, 1)
              }
            }
          }, 2000)
        }
      },
      resetDim() {
        if (this.prop.dimensions && this.prop.dimensions.length) {
          this.prop.dimensions[0].code = this.originDim.code;
          this.prop.dimensions[0].name = this.originDim.name;
        }
      },
      setDisableRequest() {
        this._disableRequest = true
        setTimeout(() => {
          this._disableRequest = false
        }, 1000)
      },
      // 获取指标维度的数据
      fetchDimentionData() {
        if (this._disableRequest) return;
        // 初始化不加载数据 用于数据权限过滤等待下拉等场景
        if (this._initUnloadData) {
          this._initUnloadData = false
          return;
        }
        let prop = this.prop
        if (!prop.dataSourceType) return;
        let defaultParam = {};
        let route = this.$route;
        let param = {};
        if (prop.dataSourceType === DATA_SOURCE_TYPE.DATA_CENTER) {
          defaultParam = [];
          // TODO 这段可能不需要 暂时不确定
          if (route && route?.query?.codeKey) {
            defaultParam.push({
              type: "dim",
              code: route.query.codeKey,
              fieldType: "String",
              oper: "EQUAL",
              filterValueList: [route.query.codeValue],
            });
          }
          let dimentionC = [];
          if (prop.dimensions?.length) {
            prop.dimensions.forEach((el) => {
              dimentionC.push({
                code: el.code,
                fieldType: el.fieldType,
                funcType: el.funcType,
                type: el.type,
                _fieldSet: this.getFieldSet(el),
              });
            })
          }
          // 行配置
          if (prop.rows?.length) {
            prop.rows.forEach((el) => {
              dimentionC.push({
                code: el.code,
                fieldType: el.fieldType,
                funcType: el.funcType,
                _fieldSet: this.getFieldSet(el),
              });
            })
          }
          // 列配置 不是明细表 明细表传到指标里
          if (prop.columns?.length && this.option.spreadSheetType === SPREAD_SHEET_TYPE.BASIC) {
            prop.columns.forEach((el) => {
              dimentionC.push({
                code: el.code,
                fieldType: el.fieldType,
                funcType: el.funcType,
                _fieldSet: this.getFieldSet(el),
              });
            })
          }
          // 对数据分组的情况下 分组的code加在维度里面 第一个是维度 第二个是分组
          //分组的情况下指标只能只能选一个 宜搭是这样的 所以这样定的 2023/07/31 找龚老师确认了
          // if (prop?.groups?.length && (!prop?.metrics || prop?.metrics?.length <= 1)) {
          if (prop?.groups?.length) {
            let gitem = prop.groups[0];
            prop.groups.forEach((el) => {
              dimentionC.push({
                code: el.code,
                fieldType: el.fieldType,
                funcType: el.funcType,
                _fieldSet: this.getFieldSet(el),
              });
            })
          }
          // TODO  测试后删除
          // if (!prop.trendDim) {
          //   prop.trendDim = [{code: 'area_code'}]
          // }
          // 趋势分析维度配置
          if (this.isTrendChart && prop.trendDim?.length) {
            prop.trendDim.forEach((el) => {
              dimentionC.push({
                code: el.code,
              });
            })
          }
          let _defaultParam = prop.filterDatas ? cloneDeep(prop.filterDatas) : {};
          // 取运行时的值
          try {
            // attrs 是aida循环需要用的
            util.handlerFilters(this.datas, [_defaultParam], this.pageParams, this.linkData, this.$attrs);
          } catch (e) {
            console.log(e);
          }
          // 下钻 增加过滤条件
          if (this.drillIndex > -1) {
            // _defaultParam
            //
            // currentClickItem
            // let dataItem = this.dataChart.find((el) => el[this.originDim.code] === this.currentClickItem.name) || {};
            if (!_defaultParam.conditions) {
              _defaultParam.conditions = []
            }
            // 默认当前第一级过滤条件
            let type = this.originDim.code.split('@')
            // 如果当前下钻的维度与初始维度相同 需要替换初始维度的过滤条件，不同就push增加过滤条件
            let currentDrillCode = this.drillDimList[this.drillIndex].code
            let filterParam = _defaultParam.conditions.find(el => el.code === currentDrillCode)
            // let currentDrillValue =
            if (filterParam) {
              filterParam.fixedValue = this.drillClickList[this.drillIndex].name
              filterParam.filterValueList = [this.drillClickList[this.drillIndex].name]
            } else {
              // 如果下钻不改维度过滤条件需要传下钻配置的code 否则使用原始维度的code
              if (this.dynamicDrill) {
                _defaultParam.conditions.push({
                  code: currentDrillCode,
                  fieldType: this.drillDimList[this.drillIndex].fieldType || 'String',
                  filterValueList: [this.drillClickList[this.drillIndex].name],
                  fixedValue: this.drillClickList[this.drillIndex].name,
                  oper: "=",
                  type: "dimName",
                  valueType: "fixedValue",
                  funcType: '',
                });
              } else {
                _defaultParam.conditions.push({
                  code: this.originDim.code,
                  fieldType: this.originDim.fieldType || 'String',
                  filterValueList: [this.drillClickList[0].name],
                  fixedValue: this.drillClickList[0].name,
                  oper: "=",
                  type: "dimName",
                  valueType: "fixedValue",
                  funcType: type[1] || '',
                });
              }
            }
            // 不改变维度才逐级增加过滤条件
            if (!this.dynamicDrill) {
              this.drillDimList.forEach((el, index) => {
                let type = el.code.split('@')
                // 面包屑导航的最后一条面包屑不需要作为过滤条件传给后台
                if (index !== this.drillDimList.length - 1) {
                  _defaultParam.conditions.push({
                    code: el.code,
                    fieldType: el.fieldType || 'String',
                    filterValueList: [this.drillClickList[index + 1].name],
                    fixedValue: this.drillClickList[index + 1].name,
                    oper: "=",
                    type: "dimName",
                    valueType: "fixedValue",
                    funcType: type[1] || ''
                  });
                }
              })
            }
          }
          let linkDim = this.currentLinkDim
          if (linkDim?.length) {
            // 基础表都加到指标里 不加维度 会查不出数据
            if (!(this.option.spreadSheetType && this.option.spreadSheetType !== SPREAD_SHEET_TYPE.BASIC)) {
              linkDim.forEach((el) => {
                dimentionC.push({
                  code: el.code,
                  fieldType: el.fieldType,
                  funcType: el.funcType,
                  _fieldSet: this.getFieldSet(el),
                });
              })
            }
          }
          // 数据分析>>>新增模型分类（数据模型和数据业务模型）,若为数据模型，则固定data_model，若业务模型走原逻辑
          // const _modelSource = modelSource_list[prop?.dataCenter?.modelType] // prop?.dataCenter?.modelCategorize === 'market' ? 'data_model' : prop?.dataCenter?.modelSource
          param = {
            type: prop.dataSourceType,
            modelSource: prop?.dataCenter?.modelSource,
            // modelSource: prop?.dataCenter?.modelType,
            dataModelId: prop?.dataCenter?.modelId,
            paramMap: {
              modelVersionNum: prop?.dataCenter?.versionNum,
              _sort_set: {limit: prop.limit},
              dimensions: dimentionC,
              kpis: this.getKpis(),
              filterDatas: _defaultParam,
              // _modelType: _modelSource,
            },
          };
        } else {
          // 带入参数
          if (prop?.conditions?.length) {
            prop.conditions.forEach((el) => {
              // 固定值后台说不需要
              // if (el.valueType === "fixedValue") {
              // 	// 带入默认值
              // 	defaultParam[el.fieldCode] = el.fixedValue || el.fixedValueList || el.fixedObjList;
              // }
              let _dv = util.deepGet(this.datas, el.bindParam, '', this.$attrs, this.pageParams, this.linkData)
              if (_dv !== null && _dv !== '') {
                defaultParam[el.fieldCode || el.code] = _dv;
              }
            });
          }
          // 对数据分组的情况下 分组的code加在维度里面 第一个是维度 第二个是分组
          let dimentionC = [];
          if (prop.dimensions?.length) {
            prop.dimensions.forEach((el) => {
              dimentionC.push(el.code);
            })
          }
          // 行配置
          if (prop.rows?.length) {
            prop.rows.forEach((el) => {
              dimentionC.push(el.code);
            })
          }

          // 列配置
          if (prop.columns?.length && this.option.spreadSheetType === SPREAD_SHEET_TYPE.BASIC) {
            prop.columns.forEach((el) => {
              dimentionC.push(el.code);
            })
          }
          if (prop?.groups?.length) {
            prop.groups.forEach((el) => {
              dimentionC.push(el.code);
            })
          }
          let linkDim = this.currentLinkDim
          if (linkDim?.length) {
            linkDim.forEach((el) => {
              dimentionC.push(el.code);
            })
          }


          param = {
            type: prop.dataSourceType,
            actionId: prop.queryAction.actionId,
            paramMap: {
              limit: prop.limit,
              modelVersionNum: prop?.dataCenter?.versionNum,
              dimension: dimentionC,
              kpis: this.getKpis(),
              filterProperties: defaultParam,
            },
            appId: prop.queryAction.appId,
            version: prop.queryAction.version,
          };
        }
        // 表格加个标识 后台处理数据
        if (this.component.prop === 'table' || this.component.prop === 'sheet') {
          // 2023 11.9 大伟要求如果分组传了数据 就改成summary 否则就是detail 明细表
          param.paramMap._sheetType = prop?.groups?.length ? 'summary' : 'detail'
        }
        // TODO 写死业务统计类型的标记 打包报错临时解决
        param.__flag = true;
        param.name = this?.$attrs?.name
        param = this.handlerDimParam ? this.handlerDimParam(param) : param;
        this.fetchParam = param;
        this.component.isLoading = true
        // 新版对象数据结构
        param.valueCode = 'NEW_STRUCTURE'
        // 后端要求
        if (this.isTrendChart || this.isRankChart) {
          param.componentType = 'indexRingGraph'
        }
        param.paramMap.guides = this.getGuidesParam()
        // 处理树形结构
        if (this.prop?.showTree) {
          param.ifTree = true
          param.idFieldName = this.prop.treeCode
          param.parentIdFieldName = this.prop.treeParentCode
        }
        return util.lowCodeRequest({
          data: param,
        }, !this.option?.dataRefreshInterval ?? false).then((el) => {
          this.component.isLoading = false
          this.handlerRes(el);
        }).finally(() => {
          this.component.isLoading = false
          this.setLoop()
        })
      },
      setLoop(flag) {
        // 自动刷新
        if (this.option.dataRefreshInterval) {
          setTimeout(() => {
            if (this._unmount) return;
            if (flag) {
              this.updateData()
            } else {
              this.fetchDimentionData().then((data) => {
                this.updateChart()
              })
            }
          }, this.option.dataRefreshInterval)
        }
      },
      getGuidesParam() {
        let res = []
        if (this.option?.referenceCustomSet?.length) {
          this.option?.referenceCustomSet.forEach((el) => {
            if (el.type === 'dynamic') {
              res.push({
                code: `${el.metric}@${el.valueType}`,
              })
            }
          })
        }
        return res
      },
      getKpis() {
        let arr = [];
        let linkMetric = this.currentLinkMetrics
        if (linkMetric?.length) {
          linkMetric.forEach((el) => {
            arr.push({
              ...el,
              type: "main",
            });
          })
        }
        if (this.prop?.metricsL?.length) {
          this.prop?.metricsL.forEach((el) => {
            arr.push({
              ...el,
              type: 'main',
            })
          })
        }
        if (this.prop?.metricsR?.length) {
          this.prop?.metricsR.forEach((el) => {
            arr.push({
              ...el,
              type: 'main',
            })
          })
        }
        if (this.prop?.longitude?.length) {
          this.prop?.longitude.forEach((el) => {
            arr.push({
              ...el,
              type: 'main',
            })
          })
        }
        if (this.prop?.latitude?.length) {
          this.prop?.latitude.forEach((el) => {
            arr.push({
              ...el,
              type: 'main',
            })
          })
        }
        if (this.prop?.metrics?.length) {
          this.prop?.metrics.forEach((el) => {
            // 非自定义指标
            if (el.type !== METRIC_TYPE.CUS) {
              arr.push({
                ...el,
                type: "main",
              })
            }
          });
        }
        // 明细表 列 算指标
        if (this.option.spreadSheetType !== SPREAD_SHEET_TYPE.BASIC && this.prop?.columns?.length) {
          this.prop?.columns.forEach((el) => {
            // 非自定义指标
            if (el.type !== METRIC_TYPE.CUS) {
              arr.push({
                ...el,
                type: "main",
              })
            }
          });
        }
        if (this.prop?.assistMetrics?.length) {
          this.prop?.assistMetrics.forEach((el) => {
            arr.push({
              ...el,
              type: "assist",
            })
          });
        }
        if (this.prop.totalMetrics?.length) {
          this.prop?.totalMetrics.forEach((el) => {
            // 非自定义指标
            if (el.type !== METRIC_TYPE.CUS) {
              arr.push({
                ...el,
                type: "main",
              })
            }
          });
        }
        if (this.prop.reference?.length) {
          this.prop?.reference.forEach((el) => {
            // 非自定义指标
            if (el.type !== METRIC_TYPE.CUS) {
              arr.push({
                ...el,
                code: el.code + '$_guides',
                type: "guides",
              })
            }
          });
        }

        let linkDim = this.currentLinkDim
        if (linkDim?.length) {
          // 基础表都加到指标里 不加维度 会查不出数据
          if (this.option.spreadSheetType && this.option.spreadSheetType !== SPREAD_SHEET_TYPE.BASIC) {
            linkDim.forEach((el) => {
              arr.push({
                code: el.code,
                fieldType: el.fieldType,
                funcType: el.funcType,
              });
            })
          }
        }

        return arr.map((el) => {
          let set = el.set || {};
          return {
            type: el.type,
            code: el.code || el.name,
            fieldType: el.fieldType,
            _fieldSet: this.getFieldSet(el),
          };
        });
      },
      getFieldSet(el) {
        let set = el.set || {}
        let _filter = {}
        if (set?.filterDatas) {
          _filter = cloneDeep(set?.filterDatas)
          // attrs 是aida循环需要用的
          util.handlerFilters(this.datas, [_filter], this.pageParams, this.linkData, this.$attrs);
        }
        return {
          basicConfig: {
            plWay: set.plWay,
            orderWay: {
              code: set.orderWay || 'noOrder',
              // 自定义排序字段
              customOrder: (set.orderWay === 'custom' && set.orderWay) ? set.customOrder.split(',') : []
            }
          },
          "showFormat": {
            "isDictName": set.type === 'dict',
            dictKey: set.dictKey
          },
          // 时间偏移
          dateOffset: {
            isDateExcursion: set.isDateExcursion,
            dateDim: set.dateDim,
            offset: set.offset,
            offsetDateDim: set.offsetDateDim,
            offsetValue: set.offsetValue,
            // TODO 爱搭增加这个字段配置
            offsetField: set.contrastIndex
          },
          // 高级计算
          highCount: {
            computeMode: set.computeMode,
            contrastIndex: set?.advancedDateOffset?.contrastIndex,
            dateOffset: {
              isDateExcursion: set?.advancedDateOffset?.isDateExcursion,
              dateDim: set?.advancedDateOffset?.dateDim,
              offset: set?.advancedDateOffset?.offset,
              offsetDateDim: set?.advancedDateOffset?.offsetDateDim,
              offsetValue: set?.advancedDateOffset?.offsetValue,
            },
          },
          // 指标配置
          indexConfig: {
            assistIndexs:
              set?.assistIndexs?.map((_el) => ({
                indexField: _el.indexField,
                showVal: _el.showVal,
              })) || [],
          },
          filterDatas: _filter
        }
      },
      // 指标卡的数据结构不同，计算指标卡的指标
      resetIndexCardCalcData(prop, dataChart, setMap) {
        let resList = [...dataChart]
        const {
          metrics = [],
          assistMetrics = [],
          totalMetrics = [],
        } = prop
        // 计算指标
        const calcMainMetrics = metrics.filter(item => !!item.formula) || []
        // 辅助计算指标
        const calcAssistMetrics = assistMetrics.filter(item => !!item.formula) || []
        // 总值计算指标
        const calcTotalMetrics = totalMetrics.filter(item => !!item.formula) || []
        // 全部计算指标
        const calcMetricsList = [...calcMainMetrics, ...calcAssistMetrics, ...calcTotalMetrics]
        if (calcMetricsList.length) {
          calcMetricsList.forEach(calcItem => {
            let calcMetricsObj = {}
            // 给返回的值暴力增加一层括号，如果是负值，在被减时可以不用挂
            const calcFormulaData = calcItem.formula.formulaData.map(formulaItem => {
              const dataItem = dataChart.find(data => data.name === formulaItem.key)
              if (String(formulaItem.type) === '4' && dataItem) {
                return `(${dataItem['_originVal']})`
              } else if (formulaItem.type === 'pageParams') {
                return `(${this.$route.query[formulaItem.key] || 0})`
              } else if (formulaItem.value === ABS_SYMBOL.ABS_LEFT) {
                return 'Math.abs('
              } else if (formulaItem.value === ABS_SYMBOL.ABS_RIGHT) {
                return ')'
              }
              return `${formulaItem.value}`
            })
            const value = new Function(`return ${calcFormulaData.join('')}`)
            let res = ''
            try {
              res = Number(value())
              // 无穷大处理成0
              // 无穷大处理成0改为处理成null, 0是有意义的数据
              if (Object.is(Infinity, res)) {
                res = null
              }
            } catch (err) {
              // 报错处理成0改为处理成null, 0是有意义的数据
              res = null
            }
            calcMetricsObj.name = calcItem.code
            calcMetricsObj.value = res
            calcMetricsObj._originVal = res
            const settingEl = setMap[calcItem.code]
            let set = settingEl?.set || {}
            if (calcItem.type === 'cus' && set.assistIndexs) {
              Promise.resolve().then(() => {
                calcMetricsObj.assistList = this.calAssist(set, calcItem, calcMetricsObj)
              })
            }
            util.formatValue(set, calcMetricsObj, 'value');
            resList.push(calcMetricsObj)
          })
        }
        resList = this.calculateIndexCardAssistCusValue(resList)
        return resList
      },
      calAssist(set, calcItem, currentObject) {
        if (!Array.isArray(this.dataChart)) return null;
        return set.assistIndexs.map((el) => {
          let {indexField, showVal} = el, res = {}
          let item = cloneDeep(this.dataChart?.find(el => el.name === indexField || el[indexField]))
          item = item[indexField] ? item[indexField] : item
          let assistSet = this.prop.assistMetrics.find(_el => _el.code === indexField)?.set
          item = {...item, value: item._originVal || item[`_${indexField}`]}
          if (showVal === 'originalVal') {
            res = {...item}
          } else if (showVal === 'differPCT') {
            res = {...item}
            if (item.value) {
              res.value = (currentObject.value - item.value) / item.value * 100
            }
          } else if (showVal === 'differAbs') {
            res = {...item, value: Math.abs(currentObject.value - item.value)}
          }
          util.formatValue(assistSet, res, 'value')
          return res;
        })
      },
      // 根据往后端返回数据，塞入计算指标数据
      resetCalcData(prop, dataChart, setMap) {
        const {
          metrics = [],
          metricsL = [],
          metricsR = [],
          reference = [],
          columns = [],
          assistMetrics = [],
          totalMetrics = [],
        } = prop
        // 计算指标
        const calcMainMetrics = metrics.filter(item => !!item.formula) || []
        // 计算指标
        const calcReference = reference.filter(item => !!item.formula) || []
        // 辅助计算指标
        const calcAssistMetrics = assistMetrics.filter(item => !!item.formula) || []
        // 总值计算指标
        const calcTotalMetrics = totalMetrics.filter(item => !!item.formula) || []
        // 列计算指标
        const calcColumns = columns.filter(item => !!item.formula) || []
        // 新增metricsL字段的计算指标
        const calcMetricsL = metricsL.filter(item => !!item.formula) || []
        // 新增metricsR字段的计算指标
        const calcMetricsR = metricsR.filter(item => !!item.formula) || []
        // 全部计算指标
        const calcMetricsList = [...calcMainMetrics, ...calcAssistMetrics, ...calcTotalMetrics, ...calcColumns, ...calcReference, ...calcMetricsL, ...calcMetricsR]
        let _dataChart = [...dataChart]
        if (calcMetricsList.length) {
          _dataChart = dataChart.map(dataItem => {
            let calcMetricsObj = {}
            const isObject = (Object.values(dataItem) || []).some(item => item !== null && typeof item === 'object')
            calcMetricsList.forEach(calcItem => {
              // 给返回的值暴力增加一层括号，如果是负值，在被减时可以不用挂
              const calcFormulaData = calcItem.formula.formulaData.map(formulaItem => {
                if (String(formulaItem.type) === '4') {
                  if (isObject) {
                    return `(${dataItem[formulaItem.key]['_originVal']})`
                  }
                  return `(${dataItem[`_${formulaItem.key}`]})`
                } else if (formulaItem.type === 'pageParams') {
                  return `(${this.$route.query[formulaItem.key] || 0})`
                } else if (formulaItem.value === ABS_SYMBOL.ABS_LEFT) {
                  return 'Math.abs('
                } else if (formulaItem.value === ABS_SYMBOL.ABS_RIGHT) {
                  return ')'
                }
                return `${formulaItem.value}`
              })
              // 传入计算字符串，计算出计算指标的结果
              const value = new Function(`return ${calcFormulaData.join('')}`)
              let res = ''
              try {
                res = Number(value())
                // 无穷大处理成0
                // 无穷大处理成0改为处理成null, 0是有意义的数据
                if (Object.is(Infinity, res)) {
                  res = null
                }
              } catch (err) {
                // 报错处理成0改为处理成null, 0是有意义的数据
                res = null
              }
              const settingEl = setMap[calcItem.code]
              let set = settingEl?.set || {}
              if (isObject) {
                calcMetricsObj[calcItem.code] = {
                  value: res,
                  _originVal: res,
                }
                if (calcItem.type === 'cus' && set.assistIndexs) {
                  Promise.resolve().then(() => {
                    calcMetricsObj[calcItem.code].assistList = this.calAssist(set, calcItem, calcMetricsObj[calcItem.code])
                  })
                }
                util.formatValue(set, calcMetricsObj[calcItem.code], 'value');
              } else {
                calcMetricsObj[calcItem.code] = res
                calcMetricsObj[`_${calcItem.code}`] = res
                util.formatValue(set, calcMetricsObj, calcItem.code);
              }

            })
            return {
              ...dataItem,
              ...calcMetricsObj,
            }
          })
        }
        _dataChart = this.calculateAssistCusValue(_dataChart)
        return _dataChart
      },
      // 指标卡辅助指标计算
      calculateIndexCardAssistCusValue(dataChart) {
        return dataChart.map(item => {
          if (item?.assistList?.length) {
            item.assistList = item.assistList.map(assistItem => {
              if (assistItem.value === null) {
                const dataObj = (dataChart.find(dataItem => dataItem.name === assistItem.name) || {})
                return {
                  ...assistItem,
                  value: dataObj.value,
                }
              }
              return assistItem
            })
          }
          return item
        })
      },
      // 非指标卡辅助指标计算
      calculateAssistCusValue(dataChart) {
        return dataChart.map(item => {
          const isObject = (Object.values(item) || []).some(dataItem => dataItem !== null && typeof dataItem === 'object')
          if (isObject) {
            for (let key in item) {
              if (item[key]?.assistList?.length) {
                item[key].assistList = item[key].assistList.map(assistItem => {
                  if (assistItem.value === null) {
                    const dataObj = item
                    return {
                      ...assistItem,
                      value: dataObj[assistItem.name]?.value || 0,
                    }
                  }
                  return assistItem
                })
              }
            }
          }
          return item
        })
      },
      // 处理aida数据配置的维度指标数据等
      getDimentionOption() {
        let option = {
          series: [],
          seriesL: [],
          seriesR: [],
          categories: []
        };
        let groupDimention;
        // 环图指标卡数据结构特殊暂时先不走分组逻辑，让后台处理，之前柱状图 折线图 分组逻辑是前台处理的。。。
        if (this.prop?.groups?.length && this.component.prop !== "pieCircleIndex") {
          let {dimention, series} = util.newGroupByData(this.dataChart, this.dcode, this.gcode, this.prop);
          groupDimention = dimention;
          option.series = series.map((el, index) => {
            return {
              ...el
            };
          });
        } else if (this.component.prop == "mixBarNew") {
          const barCf = this.prop?.metricsL?.length ? this.prop.metricsL : this.prop.barMetrics
          const lineCf = this.prop?.metricsR?.length ? this.prop.metricsR : this.prop.lineMetrics

          option.series = barCf?.map((el, index) => {
            return {
              name: el.name || "",
              // 指标环图因为设计辅助指标所以不能直接用key value了 要改成对象结构 取value
              data: this.dataChart.map((_el) => {
                if (
                  Object.prototype.toString.call(_el[el.code]) ===
                  "[object Object]" &&
                  Reflect.has(_el[el.code], "value")
                ) {
                  return _el[el.code]
                } else {
                  return {
                    ..._el,
                    value: _el[el.code],
                  }
                }
              }),
            };
          });
          // 过滤重复的维度
          let tmp = lineCf.filter(el => !barCf?.find(_el => _el.code === el.code))?.map((el, index) => {
            return {
              name: el.name || "",
              // 指标环图因为设计辅助指标所以不能直接用key value了 要改成对象结构 取value
              data: this.dataChart.map((_el) => {
                if (
                  Object.prototype.toString.call(_el[el.code]) ===
                  "[object Object]" &&
                  Reflect.has(_el[el.code], "value")
                ) {
                  return _el[el.code]
                } else {
                  return {
                    ..._el,
                    value: _el[el.code],
                  }
                }
              }),
            };
          })
          option.series = option.series.concat(tmp)
        } else {
          option.series = this.prop.metrics?.map((el, index) => {
            return {
              name: el.name || "",
              code: el.code,
              // 指标环图因为设计辅助指标所以不能直接用key value了 要改成对象结构 取value
              data: this.dataChart.map((_el) => {
                if (
                  Object.prototype.toString.call(_el[el.code]) ===
                  "[object Object]" &&
                  Reflect.has(_el[el.code], "value")
                ) {
                  return _el[el.code]
                } else {
                  return {
                    ..._el,
                    value: _el[el.code],
                  }
                }
              }),
            };
          });
          option.seriesL = this.prop.metricsL?.map((el, index) => {
            return {
              name: el.name || "",
              code: el.code,
              // 指标环图因为设计辅助指标所以不能直接用key value了 要改成对象结构 取value
              data: this.dataChart.map((_el) => {
                if (
                  Object.prototype.toString.call(_el[el.code]) ===
                  "[object Object]" &&
                  Reflect.has(_el[el.code], "value")
                ) {
                  return _el[el.code]
                } else {
                  return {
                    ..._el,
                    value: _el[el.code],
                  }
                }
              }),
            };
          })
          option.seriesR = this.prop.metricsR?.map((el, index) => {
            return {
              name: el.name || "",
              code: el.code,
              // 指标环图因为设计辅助指标所以不能直接用key value了 要改成对象结构 取value
              data: this.dataChart.map((_el) => {
                if (
                  Object.prototype.toString.call(_el[el.code]) ===
                  "[object Object]" &&
                  Reflect.has(_el[el.code], "value")
                ) {
                  return _el[el.code]
                } else {
                  return {
                    ..._el,
                    value: _el[el.code],
                  }
                }
              }),
            };
          })
        }
        const dimensionCodes = (this.prop?.dimensions || []).map(item => item.code) || []
        let _data = groupDimention || this?.dataChart?.map((el) => {

          let v = el[unref(this.dcode)]
          if (typeof v === 'object' && v && 'value' in v) {
            if (dimensionCodes?.length > 1) {
              let value = (dimensionCodes.map(code => el[code]?.value) || []).join('-')
              return value
            }
            return v?.value
          } else {
            if (dimensionCodes?.length > 1) {
              let value = (dimensionCodes.map(code => el[code]) || []).join('-')
              return value
            }
            return v
          }
        })

        if (this.isTrendChart) {
          _data = [...new Set(_data)]
          _data.sort()
        }
        option.categories = _data;
        if (this.prop?.longitude?.length) {
          option.longitude = this.prop?.longitude.map((el, index) => {
            return {
              name: el.name || "",
              data: this.dataChart.map((_el) => {
                if (
                  Object.prototype.toString.call(_el[el.code]) ===
                  "[object Object]" &&
                  Reflect.has(_el[el.code], "value")
                ) {
                  return _el[el.code]?.value
                } else {
                  return _el[el.code]
                }
              }),
            };
          })
        }
        if (this.prop?.latitude?.length) {
          option.latitude = this.prop?.latitude.map((el, index) => {
            return {
              name: el.name || "",
              data: this.dataChart.map((_el) => {
                if (
                  Object.prototype.toString.call(_el[el.code]) ===
                  "[object Object]" &&
                  Reflect.has(_el[el.code], "value")
                ) {
                  return _el[el.code]?.value
                } else {
                  return _el[el.code]
                }
              }),
            };
          })
        }
        return option;
      },
      getMarkLineDefaultSet() {
        return {
          silent: true,
          label: {
            color: this.option.yAxisColor || "#fff",
            fontSize: this.option.yAxisFontSize || 14,
            fontFamily: this.option.yAxisFontFamily,
          },
        }
      },
      // 处理参考线指标
      /**
       * 默认主指标 sub=次指标 old=老版副指标
       * @param type
       * @returns {*[]}
       */
      getMarklineOption(type) {
        let option = []
        if (this.option.yAxisMarkLineValue) {
          option = cloneDeep(this.option.yAxisMarkLineValue)
        }
        // 新版本多参考线 主指标
        let opList = cloneDeep(this.option?.referenceCustomSet)
        // 次指标
        if (type && this.option?.rightReferenceCustomSet?.length) {
          opList = cloneDeep(this.option?.rightReferenceCustomSet)
        }
        if (opList?.length) {
          opList.forEach((el) => {
            if ((el.type !== 'dynamic' && el.value !== undefined && el.value !== null) || (el.type === 'dynamic' && `${el.metric}@${el.valueType}` in (this.originDataChart?.guideValueMap || {}))) {
              let v = this.getReferenceValue(el)
              option.push({
                yAxis: v,
                lineStyle: {
                  color: el.yAxisMarkLineColor,
                  width: el.yAxisMarkLineWidth,
                  type: el.yAxisMarkLineType
                },
                label: {
                  formatter: () => `${el.name} ${v}`
                },
              })
            }
          })
        }

        if (this.prop.reference && this.prop.reference.length) {
          this.prop.reference?.forEach((el, index) => {
            let label = el.name || "";
            option.push({
              label: {
                formatter: () => label
              },
              yAxis: this.originDataChart.guidesValue || 0
            })
          });
        }
        return option;
      },
      getReferenceValue(el) {
        if (el.type !== 'dynamic') return el.value
        return this.originDataChart.guideValueMap?.[`${el.metric}@${el.valueType}`]
      },
      handlerRes(res) {
        if (util.isObject(res)) {
          this.originDataChart = cloneDeep(res)
          res = res.data || []
        }
        //  指标code和对应set的映射
        let setMap = {}
        let codeList = []
        if (this.prop.dimensions?.length) {
          codeList = codeList.concat(this.prop.dimensions)
        }
        if (this.prop.groups?.length) {
          codeList = codeList.concat(this.prop.groups)
        }
        if (this.prop.metrics?.length) {
          codeList = codeList.concat(this.prop.metrics)
        }
        if (this.prop.reference?.length) {
          codeList = codeList.concat(this.prop.reference)
        }
        if (this.prop.assistMetrics?.length) {
          codeList = codeList.concat(this.prop.assistMetrics)
        }
        if (this.prop.metricsR?.length) {
          codeList = codeList.concat(this.prop.metricsR)
        }
        if (this.prop.metricsL?.length) {
          codeList = codeList.concat(this.prop.metricsL)
        }
        if (this.prop.totalMetrics?.length) {
          codeList = codeList.concat(this.prop.totalMetrics)
        }
        // 基础表专用
        if (this.prop.values?.length) {
          codeList = codeList.concat(this.prop.values)
        }
        // 内置表格专用
        if (this.prop.columns?.length) {
          codeList = codeList.concat(this.prop.columns)
        }
        codeList.forEach((el) => {
          if (el.set) {
            setMap[el.code] = el
          }
        })
        const {
          componentType
        } = this.handlerDimParam ? this.handlerDimParam({}) : {}
        if (!componentType || componentType === "indexRingGraph") {
          codeList.forEach(codeItem => {
            // let resItem = res.find(resItem => resItem[codeItem.code] === undefined)
            res = res.map(resItem => {
              if (resItem[codeItem.code] === undefined) {
                if (!componentType) {
                  return {
                    ...resItem,
                    [codeItem.code]: undefined, // 后台未返回的字段默认成undefined，禁止私自赋0
                  }
                }
                return {
                  ...resItem,
                  [codeItem.code]: {
                    assistList: [],
                    value: undefined, // 后台未返回的字段默认成undefined，禁止私自赋0
                  },
                }
              }
              return resItem
            })
          })
        }
        res.forEach((el) => {
          let settingEl;
          //  这里是后台不是返回key value格式 返回 name value 格式 指标卡等用 特殊处理
          if (el.hasOwnProperty('name') && el.hasOwnProperty('value')) {
            settingEl = setMap[el.name]
            let set = settingEl?.set || {}
            el._originVal = cloneDeep(el['value']);
            el._dOriginVal = cloneDeep(el[this.dcode]);
            // 维度不处理
            if (this.prop.dimensions.find(_el => _el.code === settingEl.code)) {
              if (this.drillIndex === -1) {
                util.formatValue(set, el, 'value');
              }
            } else {
              util.formatValue(set, el, 'value');
            }
            //   数据有辅助指标
            if (el?.assistList?.length) {
              el?.assistList.forEach((ael) => {
                //这里找到辅助指标对应的配置
                let assistSet = this.prop.assistMetrics.find(_el => _el.code === ael.name && !_el.formula)?.set
                // 这个代表对value字段进行格式化
                util.formatValue(assistSet, ael, 'value');
              })
            }
          } else {
            for (let elKey in el) {
              settingEl = setMap[elKey]
              // 这个是前端添加的标识
              if (elKey.startsWith('_')) continue;
              if (Object.prototype.toString.call(el[elKey]) === '[object Object]') {
                el[elKey]._originVal = el[elKey].value
                el[elKey]._dOriginVal = el?.[this.dcode]?._originVal || el?.[this.dcode]?.value
              } else {
                // 这个是非对象结构 原始值只能多冗余字段存储
                el[`_${elKey}`] = el[elKey];
                el[`_dOriginVal`] = el[`_${this.dcode}`];
              }
              if (settingEl) {
                let set = settingEl.set
                // 后台会返回两种数据结构 要分别处理辅助指标 指标卡 环图指标卡 和其他组件
                if (typeof el[elKey] === 'object' && el[elKey] && 'value' in el[elKey]) {
                  // 下钻维度不格式化
                  if (this.prop.dimensions.find(_el => _el.code === elKey)) {
                    if (this.drillIndex === -1) {
                      util.formatValue(set, el[elKey], 'value');
                    }
                  } else {
                    util.formatValue(set, el[elKey], 'value');
                  }
// 处理维度的单位
                  if (set.indexUnit && this.prop.dimensions.find(_el => _el.code === elKey)) {
                    // 加单位以后的维度
                    el[elKey].value += set.indexUnit
                  }
                  //   处理辅助指标
                  if (set?.assistIndexs?.length) {
                    set?.assistIndexs.forEach((__el, _index) => {
                      //这里找到辅助指标对应的配置
                      let assistSet = this.prop.assistMetrics.find(_el => _el.code === __el.indexField)?.set
                      // 这个代表对value字段进行格式化
                      util.formatValue(assistSet, el[elKey]?.assistList?.[_index], 'value');
                    });

                  }
                } else {
                  // 下钻维度不格式化
                  if (this.prop.dimensions.find(_el => _el.code === elKey)) {
                    if (this.drillIndex === -1) {
                      util.formatValue(set, el, settingEl.code);
                    }
                  } else {
                    util.formatValue(set, el, settingEl.code);
                  }
                  // 处理维度的单位
                  if (set.indexUnit && this.prop.dimensions.find(_el => _el.code === elKey)) {
                    // 加单位以后的维度
                    el[elKey] += set.indexUnit
                  }
                }
              }
            }
          }
        });
        // 塞入计算指标的数据
        let calcType = ''
        if (this.handlerDimParam) {
          const param = this.handlerDimParam({})
          if (param && param.componentType === 'indexCard') {
            calcType = 'indexCard'
          }
        }
        let _res, func
        if (this.prop.responseHandler) {
          try {
            func = eval(`(${this.prop.responseHandler})`)
          } catch (e) {
            console.log(e)
          }
        }
        if (calcType === 'indexCard') {
          _res = this.resetIndexCardCalcData(this.prop, res, setMap);

          if (func) {
            _res = func(_res, this.prop,this,ElMessage)
          }
        } else {
          _res = this.resetCalcData(this.prop, res, setMap);
          if (func) {
            _res = func(_res, this.prop,this,ElMessage)
          }
        }
        this._originData = cloneDeep(_res)
        this.initPageInfo()
        if (this.option.showPage) {
          this.setPageData()
          if (this.option.autoPage) {
            this.startPageInterval()
          }
        } else {
          this.dataChart = _res
        }
      },
      initPageInfo() {
        this.pageIndex = 1
        this.pageCount = Math.ceil(this._originData.length / this.option.pageSize)
      },
      prePage() {
        if (this.pageIndex <= 1) {
          this.pageIndex = this.pageCount
        } else {
          this.pageIndex--
        }
        this.clearPageInterval()
        this.setPageData()
      },
      nextPage() {
        if (this.pageIndex >= this.pageCount) {
          this.pageIndex = 1
        } else {
          this.pageIndex++
        }
        this.clearPageInterval()
        this.setPageData()
      },
      startPageInterval() {
        this.clearPageInterval()
        if (!this.option.autoPage) return;
        this._pageInterval = setInterval(() => {
          this.pageIndex++
          if (this.pageIndex > this.pageCount) {
            this.pageIndex = 1
          }
          this.setPageData()
        }, (this.option.pageInterval || 4) * 1000)
      },
      clearPageInterval() {
        if (this._pageInterval) {
          clearInterval(this._pageInterval)
        }
      },
      setPageData() {
        let pageSize = this.option.pageSize
        this.dataChart = this._originData.slice((this.pageIndex - 1) * pageSize, this.pageIndex * pageSize)
        this.updateChart()
      },
      // 根据code 和 value 自动对联动数据进行赋值,图表在自定义事件中调用此方法 默认在click调用
      setLinkData(dimCode = this.dcode, value, itemValue) {
        let item
        if (value === DEFAULT_VALUE_TYPR.CLEAR) {
          for (const currentLinkDataKey in this.currentLinkData) {
            // 不是name的key全部赋值为当前点击的数据源
            if (currentLinkDataKey !== 'name') {
              this.currentLinkData[currentLinkDataKey].value = ''
            }
          }
          return;
        }
        if (itemValue) {
          item = itemValue
        } else {
          let dataList = this.dataChart
          if (this.prop.showTree) {
            dataList = flattenTree(dataList)
          }
          if (this.component.prop !== 'indexCard') {
            item = dataList?.find && dataList.find(el => el[dimCode] == value || el[dimCode]?.value === value)
          } else {
            // 指标卡数据结构不同，没有维度，单独处理
            item = dataList?.find && dataList.find(el => el.name == value)
          }
        }
        for (const currentLinkDataKey in this.currentLinkData) {
          // 不是name的key全部赋值为当前点击的数据源
          if (currentLinkDataKey !== 'name') {
            // 这里需要处理是否为维度，因为维度前台处理加了单位 传值需要去掉单位给后台 怎么样？ 要是阁下做这个需求准备如何应对？
            // 这个标记是处理保留原始值的标记比如 2023 前台处理成 2023年 _year = 2023    year=2023年
            if (item && `_${currentLinkDataKey}` in item) {
              this.currentLinkData[currentLinkDataKey].value = item[`_${currentLinkDataKey}`]?.value || item[`_${currentLinkDataKey}`]
            } else {
              // 兼容传递任意不在数据表的时间查询，强行塞值，没有很好方案的临时方式
              if (this.component.prop !== 'indexCard') {
                this.currentLinkData[currentLinkDataKey].value = item ? (item[currentLinkDataKey]?.value || item[currentLinkDataKey]) : value
              } else {
                // 指标卡数据结构不同，单独处理
                this.currentLinkData[currentLinkDataKey].value = item ? item.value : value
              }
            }
          }
        }
      },

      // 动态下钻是否可以继续下钻
      canDrill() {
        // 安环如果组织类型是5就不下钻
        let dillOrgType = this.currentClickItem?.data?.originData?.['org_category$_assist']?.value || this.currentClickItem?.data?.originData?.['org_category$_assist'] || this.currentClickItem?.data?.['org_category$_assist']
        return String(dillOrgType) !== '5'
      },
      multiDrillHandler(e) {
        let set = this.currentDrillSet
        let drillLength = this.currentDrillSet.drillList?.length;
        // 	下钻
        if (!set?.drillType || !this.canDrill()) return;
        if (set?.drillType !== DRILL_TYPE.OUT && drillLength) {
          // 动态下钻无限下钻
          if (this.dynamicDrill) {
            this.drillIndex++;
          } else {
            if (this.drillIndex < drillLength - 1) {
              this.drillIndex++;
            }
          }
          // 	跳转路由
        } else {
          // 外部页面
          let name = e.name
          if (set.indexUnit) {
            name = name.replace(set.indexUnit, '')
          }
          let p;
          if (set?.drillPageType === "aida") {
            if (set.aidaPagePath) {
              p = set.aidaPagePath;
            }
            this.$router.push({
              path: p,
              query: {
                value: name,
              },
            });
          } else {
            if (set?.drillRoute) {
              p = set.drillRoute;
            }
            location.href = `${P}?value=${name}`
          }
        }
      },
      multiDrill(item, index) {
        this.$emit('clickItem', {bsItem: this, clickItem: this.currentClickItem});
        if (this.component.prop !== 'sheet') {
          this.setLinkData(this.gcode || this.dcode, this.currentClickItem.name)
        }
        if (index !== undefined) {
          this.currentDrillRouteIndex = index
        }
        this.multiDrillHandler(item)
      },
      multiJump(item, index) {
        if (!this.isAutoJump) return;
        if (this.component.prop !== 'sheet') {
          try {
            this.cacheLinkData()
            this.setLinkData(this.gcode || this.dcode, this.currentClickItem.name)
          } catch (e) {
            console.log(e)
          }
        }
        let jumpItem = item
        if (jumpItem.bigJumpType === BIG_JUMP_TYPE.AIDA) {
          this.aidaJump(jumpItem)
        } else if (jumpItem.bigJumpType === BIG_JUMP_TYPE.EXTERNAL) {
          this.BSJump(jumpItem)
        }
        // 记得跳转后关闭这个变量
        this.multiActionsParam.showMultiAction = false
        // 跳转需要获取联动数据 但是如果同时有下钻配置，那么仅当点击下钻时才能设置联动数据，否则点击跳转也会触发下钻联动，所以回退联动数据，暂时无好的解决办法
        this.rollbackLinkData()
      },
      cacheLinkData() {
        this._cacheLinkData = JSON.parse(JSON.stringify(this.currentLinkData));
      },
      rollbackLinkData() {
        for (const currentLinkDataKey in this.currentLinkData) {
          if (currentLinkDataKey !== 'name') {
            this.currentLinkData[currentLinkDataKey].value = this._cacheLinkData[currentLinkDataKey].value
          }
        }
      },
      aidaJump(jumpItem) {
        let params = {}
        if (Array.isArray(jumpItem.jumpParams)) {
          jumpItem.jumpParams.forEach((el) => {
            params[el.paramKey] = util.deepGet(this.datas, el.bindParam, '', this.$attrs, this.pageParams, this.linkData);
          })
        }
        let query = qs.stringify(params)
        // 大屏
        if (this.editorType === 1) {
          let url = jumpItem.aidaDomain + jumpItem.jumpRoute + `?${query}`
          // 跳转大屏页面替换token
          url = this.replaceTokenUrl(url)
          if (jumpItem.openType === OPEN_PAGE_TYPE.INNER) {
            location.href = url;
          } else if (jumpItem.openType === OPEN_PAGE_TYPE.TAB) {
            window.open(url);
          }
        } else {
          // 在 爱搭搭建的看板
          let BUS = useEventBus("eventHandler");
          let _params = []
          for (const paramsKey in params) {
            _params.push({
              paramKey: paramsKey,
              value: params[paramsKey]
            })
          }
          BUS.emit({
            type: EVENT_TYPE.OPEN_PAGE,
            payload: {...jumpItem, params: _params, actionContent: jumpItem.aidaPageId, _triggerRef: this.triggerRef},
          });
        }
      },
      BSJump(jumpItem) {
        if (jumpItem.bigJumpKind == "back") {
          if (this.$router) {
            this.$router.back();
          } else {
            window.top.history.back();
          }
          return;
        }
        let params = {}
        let defaultParams = []
        if (Array.isArray(jumpItem.jumpParams)) {
          jumpItem.jumpParams.forEach((el) => {
            params[el.paramKey] = util.deepGet(this.datas, el.bindParam, '', this.$attrs, this.pageParams, this.linkData);
            defaultParams.push({
              key: el.paramKey,
              value: params[el.paramKey]
            })
          })
        }
        if (Array.isArray(jumpItem.fieldList)) {
          jumpItem.fieldList.forEach((el) => {
            params['metricCode'] = el.code
            params['metricName'] = el.name
            defaultParams.push({
              key: 'metricCode',
              value: el.code,
            })
            defaultParams.push({
              key: 'metricName',
              value: el.name,
            })
          })
        }
        let query = qs.stringify(params)

        let url
        if (jumpItem.externalPathType === LINK_TYPE.STATIC) {
          url = jumpItem.externalPath
        } else if (jumpItem.dynamicExternalPath) {
          try {
            url = eval(`(${jumpItem.dynamicExternalPath})`)(this.currentClickItem, params, this)
          } catch (e) {
            console.log(e)
          }
        }
        if (url && url.indexOf('?') < 0) {
          url = this.replaceTokenUrl(url + `?${query}`)
        } else if (url && url.indexOf('?') >= 0) {
          url = this.replaceTokenUrl(url + `&${query}`)
        }
        if (jumpItem.bigJumpKind == "inner") {
          if (!(url?.startsWith("http") || url?.startsWith("https"))) {
            this.$router.push(url);
          } else {
            location.href = url;
          }
        } else if (jumpItem.bigJumpKind == "dialog") {
          if (!(url?.startsWith("http") || url?.startsWith("https"))) {
            url = `${window.location.origin}${
              url.startsWith("/") ? "" : "/"
            }${url}`;
          }
          let BUS = useEventBus("eventHandler");
          BUS.emit({
            type: EVENT_TYPE.OPEN_PAGE,
            payload: {...jumpItem, url, openType: 'dialog', defaultParams: defaultParams, _triggerRef: this.triggerRef}
          })
        } else {
          if (!(url?.startsWith("http") || url?.startsWith("https"))) {
            url = `${window.location.origin}${
              url.startsWith("/") ? "" : "/"
            }${url}`;
          }
          if (window.location?.ancestorOrigins?.[0]?.includes('bi.') || window.location?.href?.includes('bi.')) {
            window.open(url);
          } else {
            let info = this.parseUrlInfo(url)
            window.parent.postMessage({
              origin: "web-prj",
              type: "open",
              menu: info.path,
              data: info.params
            }, "*");
          }
        }
      },
      parseUrlInfo(url) {
        try {
          const parsedUrl = new URL(url);

          // 获取路径部分
          const path = parsedUrl.pathname;

          // 获取 query 参数并转换为对象
          const params = {};
          for (const [key, value] of parsedUrl.searchParams.entries()) {
            params[key] = value;
          }

          return {
            path,     // 如 /projectManage/userManage/index
            params    // 如 { id: '1824331558208634882' }
          };
        } catch (e) {
          console.error('无效的 URL:', url);
          return null;
        }
      },
      // 跳转逻辑 爱搭跳转和第三方跳转
      jump(e) {
        if (!this.isAutoJump) return;
        if (this.prop.bigJumpKind == "back") {
          if (this.$router) {
            this.$router.back();
          } else {
            window.top.history.back();
          }
          return;
        }
        let params = {}
        if (Array.isArray(this.prop.jumpParams)) {
          this.prop.jumpParams.forEach((el) => {
            params[el.paramKey] = util.deepGet(this.datas, el.bindParam, '', this.$attrs, this.pageParams, this.linkData);

          })
        }
        let query = qs.stringify(params)
        if (this.prop.bigJumpType === BIG_JUMP_TYPE.AIDA) {
          if (this.prop.aidaDomain && this.prop.bigJumpPath) {
            if (this.prop.bigJumpKind == "inner") {
              location.href = `${this.prop.aidaDomain}${this.prop.bigJumpPath}?${query}`;
            } else {
              window.open(
                `${this.prop.aidaDomain}${this.prop.bigJumpPath}?${query}`
              );
            }
          }
        } else {
          let url
          if (this.prop.externalPathType === LINK_TYPE.STATIC) {
            url = this.prop.externalPath
          } else if (this.prop.dynamicExternalPath) {
            try {
              url = eval(`(${this.prop.dynamicExternalPath})`)(e, params, this);
            } catch (e) {
              console.log(e)
            }
          }
          if (url && url.indexOf('?') < 0) {
            url = this.replaceTokenUrl(url + `?${query}`)
          } else if (url && url.indexOf('?') >= 0) {
            url = this.replaceTokenUrl(url + `&${query}`)
          }
          if (this.prop.bigJumpKind == "inner") {
            if (!(url?.startsWith("http") || url?.startsWith("https"))) {
              this.$router.push(url);
            } else {
              location.href = url;
            }
          } else if (this.prop.bigJumpKind == "dialog") {
            if (!(url?.startsWith("http") || url?.startsWith("https"))) {
              url = `${window.location.origin}${
                url.startsWith("/") ? "" : "/"
              }${url}`;
            }
            let BUS = useEventBus("eventHandler");
            BUS.emit({type: EVENT_TYPE.OPEN_PAGE, payload: {url, openType: 'dialog', _triggerRef: this.triggerRef}})
          } else {
            if (!(url?.startsWith("http") || url?.startsWith("https"))) {
              url = `${window.location.origin}${
                url.startsWith("/") ? "" : "/"
              }${url}`;
            }
            window.open(url);
          }
        }
      },
      // 拼接替换跳转链接中的token
      replaceTokenUrl(url) {
        //   相对地址 拼接上当前协议和域名
        // const token = this.$route.query.token || this.$route.query.sessionKey
        // 改为从local取
        const token = localStorage.getItem('accessToken')
        let newUrl = ''
        if (url[url?.length - 1] !== '&' && url[url?.length - 1] !== '?') {
          newUrl = url.indexOf('?') < 0 ? `${url}?` : `${url}&`
        } else {
          newUrl = url
        }
        // 兼容部分场景需要去掉sessionKey
        if (url.indexOf('sessionKey=null') >= 0) {
          return newUrl.substring(0, newUrl?.length - 1);
        }
        return `${newUrl}sessionKey=${token}`;
      },
      // 更新数据核心方法
      updateData(p = {}) {
        let record, key = false;
        let isRecord = this.dataType === 4;
        let isPublic = this.dataType === 5
        this.dataParams = Object.assign(this.dataParams, p)
        return new Promise((resolve, reject) => {
          this.resetData && this.resetData();
          if (key) return;
          key = true;
          let safe = this
          const formatter = (data, params) => {
            this.dataOldChart = data;
            if (isRecord) {
              const dataFormatter = getFunction(safe.dataFormatter)
              if (typeof dataFormatter == 'function') {
                data = dataFormatter(data)
              }
            }
            if (typeof this.dataFormatter === 'function') {
              try {
                data = this.dataFormatter(data, params, this.getItemRefs());
              } catch (err) {
                console.log(new Error(err))
                data = err + ''
              }
            }
            return data
          }
          const getData = () => {
            safe = record || this
            key = false;
            let isApi = safe.dataType === 1;
            let isSql = safe.dataType === 2;
            let isWs = safe.dataType === 3;
            let isMqtt = safe.dataType == 6;
            this.closeClient()
            const bindEvent = () => {
              if (this.myChart) {
                [{
                  name: 'click',
                  event: 'handleClick'
                }, {
                  name: 'dblclick',
                  event: 'handleDblClick'
                }, {
                  name: 'mouseover',
                  event: 'handleMouseEnter'
                }, {
                  name: 'mouseout',
                  event: 'handleMouseLeave'
                }].forEach(ele => {
                  this.myChart.off(ele.name);
                  this.myChart.on(ele.name, e => this[ele.event](e, e.dataIndex));
                })
              }
              if (typeof this.stylesFormatter === 'function') {
                this.styles = this.stylesFormatter(this.dataChart, this.dataParams, this.getItemRefs()) || {};
              }
              resolve({
                news: this.dataChart,
                old: this.dataOldChart
              });
              // 这里需要延迟等dom加载完 echarts才能正确渲染 nexttick无效
              // console.log('updateChart>>>>')
              setTimeout(this.updateChart, 500)
            }
            if (this.isDataCenter && this.prop.dataSourceType === DATA_SOURCE_TYPE.DATA_CENTER && this.prop?.dataCenter?.modelId) {
              // 配置了模型才请求接口
              const _res = this.fetchDimentionData()
              _res && _res.then(() => {
                bindEvent();
              })
            } else if (this.isDataCenter && this.prop.queryAction?.actionId) {
              const _res = this.fetchDimentionData()
              _res && _res.then(() => {
                bindEvent();
              })
            } else if (isApi) {
              let url = safe.url;
              if (this.validatenull(url)) return
              let dataQuery = getFunction(safe.dataQuery)
              dataQuery = typeof (dataQuery) === 'function' && dataQuery(url) || {}
              let dataHeader = getFunction(safe.dataHeader)
              dataHeader = typeof (dataHeader) === 'function' && dataHeader(url) || {}
              let params = Object.assign(dataQuery, this.dataParams);
              let axiosParams = {}
              if (safe.proxy) dataHeader.proxy = true;
              if (['post', 'put'].includes(safe.dataMethod)) {
                axiosParams.data = params
                if (safe.dataQueryType == 'form') {
                  if (safe.proxy) dataHeader.form = true
                  let formData = []
                  Object.keys(params).forEach(ele => {
                    formData.push(`${ele}=${params[ele]}`)
                  })
                  axiosParams.data = formData.join('&')
                }
              } else if (['get', 'delete'].includes(safe.dataMethod)) {
                axiosParams.params = params
              }
              this.$axios({
                ...{
                  method: safe.dataMethod,
                  url: url,
                  headers: dataHeader,
                },
                ...axiosParams
              }).then(res => {
                this.dataAxios = res;
                let result = res.data;
                result = formatter(result, params)
                if (this.dataAppend) {
                  this.updateAppend(result)
                } else {
                  this.dataChart = result;
                }
                bindEvent();
              });
            } else if (isWs) {
              let url = safe.wsUrl
              if (this.validatenull(url)) return
              let dataQuery = getFunction(safe.dataQuery)
              dataQuery = typeof (dataQuery) === 'function' && dataQuery(url) || {}
              let params = Object.assign(dataQuery, this.dataParams);
              url = url + addParam(params)
              this.wsClient = new WebSocket(url)
              this.wsClient.onmessage = (msgEvent = {}) => {
                let result = JSON.parse(msgEvent.data)
                this.dataChart = formatter(result, this.dataParams)
                bindEvent();
              }
            } else if (isSql) {
              let sql = JSON.parse(crypto.decrypt(safe.sql));
              let data, result;
              try {
                sql.sql = funEval(sql.sql)(this.dataParams)
                data = crypto.encrypt(JSON.stringify(sql));
              } catch (error) {
                data = safe.sql;
              }
              this.sqlFormatter(data).then(res => {
                result = res;
                this.dataChart = formatter(result, this.dataParams)
                bindEvent();
              })
            } else if (isMqtt) {
              // let url = safe.mqttUrl
              // let dataMqttConfig = JSON.parse(safe.mqttConfig)
              // this.mqClient = mqtt.connect(url, dataMqttConfig)
              // this.mqClient.subscribe(dataMqttConfig.topic.name, {qos: dataMqttConfig.topic.qos}, (error, res) => {
              //   console.log('Subscribe to topics res', res, error)
              // })
              // this.mqClient.on('message', (topic, message) => {
              //   let defaultTopic = dataMqttConfig.topic
              //   if (topic === defaultTopic.name) {
              //     let result = JSON.parse(message)
              //     this.dataChart = formatter(result, this.dataParams)
              //     bindEvent()
              //   }
              // })

            } else if (isPublic) {
              let refList = this.getItemRefs();
              let result = refList[this.public].dataChart
              this.dataChart = formatter(result, this.dataParams)
              bindEvent();
            } else {
              let result = safe.data || util.getOptionData(safe);
              if (isRecord) {
                result = funEval(result)
              }
              this.dataChart = formatter(result, this.dataParams)
              bindEvent();
              this.setLoop(true)
            }
          };
          const sendData = () => {
            this.$nextTick(() => {
              getData();
              clearInterval(this.checkChart);
              if (isPublic) {
                this.checkChart = setInterval(() => {
                  getData();
                }, 100);
              }
              if (this.time !== 0 && this.disabled) {
                this.checkChart = setInterval(() => {
                  getData();
                }, this.time);
              }
            });
          }
          if (isRecord) {
            this.recordFormatter(this.record).then(res => {
              const data = res;
              record = {
                ...data,
                sql: data.data
              }
              sendData()
            })
          } else {
            sendData()
          }
        })
      },
      handleCommonBind(item, index, type) {
        if (type == 'clickFormatter') {
          this.updateClick(item || this.dataChart);
        }
        let params = {}
        if (!this.validatenull(index)) {
          params = {
            item,
            index,
            data: this.dataChart
          }
          if (item.value) params.value = item.value
        } else {
          params = item || this.dataChart
        }
        this[type] && this[type](params, this.getItemRefs());
      },
      handleClick(item, index) {
        item = cloneDeep(item)
        this.generateJumpFilterData(item)
        // item.data._dOriginVal 原始维度值, 指标卡数据结构不同需要直接传code来set指标值
        item.name = this.component.prop !== 'indexCard' ? (item?.data?._dOriginVal || item.name) : item.code
        // 多路径
        let set = this.prop?.dimensions?.[0]?.set;
        // 需要显示操作弹窗 有这两个配置说明是新版配置
        if (set?.drillActions?.length || this.prop?.jumpActions?.length) {
          this.currentClickItem = item
          this.showActions(item)
          // if (this.currentDrillRouteIndex > -1) {
          //   this.multiDrill(item)
          // } else {
          //   this.showActions(item)
          // }
        } else {
          this.$emit('clickItem', {bsItem: this, clickItem: this.currentClickItem});
          this.setLinkData(this.gcode || this.dcode, item.name)
          // 兼容原来的配置逻辑
          this.drillHandler(item, index)
          this.jump(item)
        }
        this.handleCommonBind(item, index, 'clickFormatter')
      },
      generateJumpFilterData(clickItem) {
        console.log('clickItem', clickItem)
        this.prop.currentShowJumpAction = this.prop?.jumpActions?.filter(jumpAct => {
          if (jumpAct.fieldList?.length) {
            if (jumpAct.fieldList.find(fieldItem => fieldItem.name === clickItem.seriesName || fieldItem.code === clickItem.code)) {
              return true
            }
            return false
          }
          return true
        })
      },
      showActions(e) {
        if (e.event && e.event) {
          this.multiActionsParam.clickParams = {offsetX: e.event.offsetX, offsetY: e.event.offsetY}
        }
        this.multiActionsParam.showMultiAction = true
      },
      drillHandler(e) {
        let set = this.prop.dimensions?.[0]?.set;
        let drillLength = set?.drillList?.length;
        this.currentClickItem = e;
        // 	下钻
        if (!set?.drillType) return;
        if (set?.drillType === DRILL_TYPE.IN && drillLength) {
          if (this.drillIndex < drillLength - 1) {
            this.drillIndex++;
          }
          // 	跳转路由
        } else {
          // 外部页面
          let name = e.name
          if (set.indexUnit) {
            name = name.replace(set.indexUnit, '')
          }
          let p;
          if (set?.drillPageType === "aida") {
            if (set.aidaPagePath) {
              p = set.aidaPagePath;
            }
            this.$router.push({
              path: p,
              query: {
                value: name,
              },
            });
          } else {
            if (set?.drillRoute) {
              p = set.drillRoute;
            }
            location.href = `${P}?value=${name}`
          }
        }
      },
      getDrillITem(index, list = this.prop.rDimensions) {
        if (index > -1) {
          let dim
          if (this.dynamicDrill) {
            dim = this.prop.dimensions?.[0]?.set?.drillActions?.[0].drillList[0]
          } else {
            dim = this.currentDrillRouteIndex > -1 ? this.currentDrillSet?.drillList[index] : this.prop.dimensions?.[0]?.set?.drillList[index];
          }
          // 找到下钻维度code
          let res;
          for (let i = 0; i < list.length; i++) {
            let el = list[i];
            if (el.code === dim) {
              return el;
            }
            if (el?.children?.length) {
              res = this.getDrillITem(index, el.children);
            }
            if (res) return res;
          }
        }
      },
      handleDblClick(item, index) {
        this.handleCommonBind(item, index, 'dblClickFormatter')
      },
      handleMouseEnter(item, index) {
        this.handleCommonBind(item, index, 'mouseEnterFormatter')
      },
      handleMouseLeave(item, index) {
        this.handleCommonBind(item, index, 'mouseLeaveFormatter')
      },
      setEvent() {
        useEventListener(this.$el, 'mouseenter', () => {
          if (this._originData) {
            this.mouseEnter()
          }
        })
        useEventListener(this.$el, 'mouseleave', () => {
          if (this._originData) {
            this.mouseLeave()
          }
        })
      },
      mouseEnter() {
        this.isHovering = true;
        this.clearPageInterval()
      },
      mouseLeave() {
        this.isHovering = false;
        if (this.option.autoPage) {
          this.startPageInterval()
        }
      },
      // 下面俩都是chart的公共的方法,就放这里面共用
      getColor(index, first) {
        const barColor = this.option.barColor && this.option.barColor?.length ? this.option.barColor : (this.themeCfg.barColor || []);
        // 颜色循环取 原来的有bug
        index = index % barColor.length
        if (barColor[index]) {
          const color1 = barColor[index].color1 || '#ffffff';
          const color2 = barColor[index].color2;
          const postion = (barColor[index].postion || 0.9) * 0.01;
          if (first) return color1;
          if (color2) {
            return {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: color1 // 0% 处的颜色
              }, {
                offset: postion,
                color: color2 // 100% 处的颜色
              }],
              global: false // 缺省为 false
            };
          }
          return color1;
        }
      },
      getHorizontalColor(index, first) {
        const barColor = this.option.barColor || [];
        if (barColor[index]) {
          const color1 = barColor[index].color1;
          const color2 = barColor[index].color2;
          const postion = (barColor[index].postion || 0.9) * 0.01;
          if (first) return color1;
          if (color2) {
            return {
              type: 'linear',
              x: 1,
              y: 0,
              x2: 0,
              y2: 0,
              colorStops: [{
                offset: 0,
                color: color1 // 0% 处的颜色
              }, {
                offset: postion,
                color: color2 // 100% 处的颜色
              }],
              global: false // 缺省为 false
            };
          }
          return color1;
        }
      },
      getHasProp(isHas, propObj, staticObj = {}) {
        return Object.assign((() => {
          return isHas ? propObj : {};
        })(), staticObj);
      },
      closeClient() {
        this.wsClient.close && this.wsClient.close()
        this.mqClient.end && this.mqClient.end()
        this.mqClient.close && this.mqClient.close()
      },
      handlerDimParam(param) {
        // 指标环图结构, 辅助指标显示在柱状图复用，通过assistTip字段加一层控制
        param.componentType = this.option.assistTip ? 'indexRingGraph' : undefined;
        return param
      },
      getDataZoom() {
        let res = []
        if (this.option.showDataZoom) {
          res = [{
            show: true,
            start: 0,
            end: 50,
          },
            {
              type: 'inside',
              start: 0,
              end: 50,
            }]
        }
        return res
      },
      echartsOptionHandler(option) {
        let strFun = this.prop.echartsOptionHandler
        let op = option
        if (strFun) {
          try {
            let func = eval(`(${strFun})`)
            op = func({
              option, dataChart: this.dataChart, prop: this.prop, datas: this.datas, linkData: this.linkData
            })
          } catch (e) {
            console.log(e)
          }
        }
        return op
      },
      getModelInfo(v) {
        if (!v) {
          if (this.prop?.dataCenter?.modelId) {
            v = this.prop.dataCenter.modelId;
          } else {
            return;
          }
        }
        let model = this.prop.dataCenter;
        // 模型 类型
        const modelSource_list = {
          market: 'data_model',
          biz_unit_app: 'biz_data_model',
          biz_unit: model?.modelSource
        }
        // 服务类型
        const serviceType_list = ServiceTypeList

        dataCenterDao
          .getParams({
            timeStamp: Date.now(),
            modelCode: model.modelId,
            modelVersionNum: model?.sourceVersionNum || model?.versionNum,
            serviceType: serviceType_list[model?.modelCategorize], // selectAppType.value === 'market' ? DATA_SOURCE_TYPE.REPORT : DATA_SOURCE_TYPE.DATA_CENTER, // 2023年12月21日，大老师同步，数据模型传dataReport，业务模型传dataCount
            // serviceType: props.isIndexCard ? DATA_SOURCE_TYPE.REPORT : DATA_SOURCE_TYPE.DATA_CENTER,
            modelSource: modelSource_list[model?.modelCategorize],

          })
          .then((res) => {
            this.prop.rMetrics = res.kpiList ?? [];
            this.prop.rDimensions = res.dimList ?? [];
            this.prop.rConditions = res.filterList ?? [];
          }).catch((err) => {
          console.log(err)
        });
      },
      findTreeItem(tree, key, value) {
        for (const node of tree) {
          if (node[key] === value) return node;
          if (node.children && node.children.length) {
            const found = this.findTreeItem(node.children, key, value);
            if (found) return found;
          }
        }
        return null;
      },
    },
    beforeDestroy() {
      clearInterval(this.checkChart);
      this.closeClient()
    },
    beforeUnmount() {
      this.resetDim()
      this._unmount = true
    }
  };
})();
